import request from '../utils/request'

export function postDayDishDris(params,token) {
  return request({
    url: '/syDayDish/getDris',
    method: 'post',
    data:params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': token
    }
  })
}

  export function postSyparamSelectList(params) {
    return request({
      url: '/syparam/selectList',
      method: 'post',
      data:params
    })
  }

  export function postAiSendPromptMsg(params) {
    return request({
      url: '/ai/sendPromptMsg',
      method: 'post',
      data:params,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }

  export function postAiSendMsg(params) {
    return request({
      url: '/ai/sendMsg',
      method: 'get',
      params,
      headers: {
        'Content-Type': 'application/json',
      },
    })
  }



 

  export function postStatisticsCourseHourStatistics(params) {
    return request({
      url: '/statistics/courseHourStatistics',
      method: 'post',
      data:params
    })
  }

  export function postStatisticsCourseOverview(params) {
    return request({
      url: '/statistics/courseOverview',
      method: 'post',
      data:params
    })
  }

  export function postDataPermissionsGetOrgs(params) {
    return request({
      url: '/dataPermissions/getOrgs',
      method: 'get',
      params:params
    })
  }

// 获取班课在册人数统计
export function postClassStudentStatistics(params) {
    return request({
      url: '/statistics/classStudentStatistics',
      method: 'post',
      data:params
    })
  }

  // 老师详情
  export function postTeacherCourse(params) {
    return request({
      url: '/statistics/teacherCourse',
      method: 'post',
      data:params
    })
  }

// 类型统计数据
export function postHourTypeStatistics(params) {
  return request({
    url: '/statistics/hourTypeStatistics',
    method: 'post',
    data: params
  })
}

// 学部统计数据
export function postHourPeriodStatistics(params) {
  return request({
    url: '/statistics/hourPeriodStatistics',
    method: 'post',
    data: params
  })
}

// 班级课时列表数据
export function postHourClassStatistics(params) {
  return request({
    url: '/statistics/hourClassStatistics',
    method: 'post',
    data: params
  })
}

// 老师课时列表数据
export function postHourTeacherRanking(params) {
  return request({
    url: '/statistics/hourTeacherRanking',
    method: 'post',
    data: params
  })
}

// 班主任课时列表数据
export function postHourClassTeacherStatistics(params) {
  return request({
    url: '/statistics/hourClassTeacherStatistics',
    method: 'post',
    data: params
  })
}

// 年级课时列表数据
export function postHourGradeStatistics(params) {
  return request({
    url: '/statistics/hourGradeStatistics',
    method: 'post',
    data: params
  })
}

// 个性化课时列表数据
export function postHourPersonalStatistics(params) {
  return request({
    url: '/statistics/hourPersonalStatistics',
    method: 'post',
    data: params
  })
}
